import { useApplicationContext } from '../../../utils/applicationContext';
import { Microfrontend } from '@cian/mf-react';
import { IWidgetManifest } from '../../../types/widgetManifest';

export const SubsidizedMortgageContainer = () => {
  const { config, logger } = useApplicationContext();

  const manifest = config.get<IWidgetManifest>('subsidizedMortgageCalculatorManifest');

  if (!manifest) {
    logger.error('Отсутствует манифест микрофронта Калькулятора субсидированной ипотеки', {
      domain: 'microfrontends.subsidized-mortgage-calculator.manifest',
    });

    return null;
  }

  return <Microfrontend {...manifest} />;
};
